

































import { Component, Vue } from "vue-property-decorator";
import Modal from "./Modal.vue";

@Component({
  components: { Modal }
})
export default class ToolbarFeedbackAction extends Vue {
  modal = false;
  type = "";

  show(type: string) {
    this.modal = true;
    this.type = type;
  }
}
